module.exports = __webpack_public_path__ + "static/img/loading.7946a97.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/loading.gif
// module id = 4iab
// module chunks = 28